import { ReactElement, ReactNode } from 'react';
import './GlobalStyles.scss';
interface GlobalStylesProps {
  children: ReactNode;
}

function GlobalStyles({ children }: GlobalStylesProps): ReactElement {
  return <>{children}</>;
}
export default GlobalStyles;
